import React from 'react'
import { Flex, Spinner } from '@chakra-ui/core'
import colors from 'constants/colors'

export interface ILoaderProps {
  size?: 'sm' | 'md' | 'xl'
  color?: string
  h?: string
}

export const Loader: React.FC<ILoaderProps> = ({ size = 'xl', color = colors.blueMedium, h = '200px' }) => (
  <Flex justifyContent="center" alignItems="center" h={h}>
    <Spinner size={size} color={color} />
  </Flex>
)
